import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React from 'react';
import { globalStyles } from 'snacks-design-system';
import { useTranslation } from 'react-i18next';

const { xdsSpacingB } = globalStyles;

const TagAssigned = () => {
  const { t } = useTranslation();
  return (
    <PIETag mode={ETagsColorType.Neutral}>
      <PIEComponentUtil paddingX={xdsSpacingB}>
        {t('order.status_ASSIGNED')}
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagAssigned;
